import axios from 'axios';
import { getToken, limparSessao } from '../utils/sessao';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:3001/api',
});

// Token lido a CADA requisição (sessão por guia: sessionStorage → localStorage)
api.interceptors.request.use((cfg) => {
  const token = getToken();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // Só 401 (token ausente/inválido/expirado) derruba a sessão.
    // 403 = permissão negada (perfil sem o menu / ação exige admin) — o
    // usuário continua logado; a tela trata o erro. Deslogar em 403 expulsava
    // perfis restritos para o login ao abrir qualquer tela com fetch bloqueado.
    if (err.response?.status === 401) {
      limparSessao();
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
